import SamplePage from '../Components/Pages/PageLayout/SimplePage';
import Dashboard from '../Components/Pages/Dashboard';
import InsuranceCompanies from '../Components/Pages/InsuranceCompanies/InsuranceCompanies';
import Banks from '../Components/Pages/Banks/Banks';
import JobPool from '../Components/Pages/JobPool/JobPool';
import Employees from '../Components/Pages/Employees/Employees';
import CallForm from '../Components/Pages/CallForms/CallForm';
import PendingCallForm from '../Components/Pages/CallForms/PendingCallForm/PendingCallForm';
import TodoList from '../Components/Pages/TodoList/TodoList';
import CustomerList from '../Components/Pages/Customers/CustomerList/Customers';
import CustomerDetail from '../Components/Pages/Customers/CustomerDetail';
import LicensePlates from '../Components/Pages/LicensePlates/LicensePlates';
import Accidents from '../Components/Pages/Accidents/Accidents';
import AccidentFiles from '../Components/Pages/AccidentFiles/AccidentFiles';
import Enforcements from '../Components/Pages/Enforcements/Enforcements';
import FileTypes from '../Components/Pages/Types/FileTypes/FileTypes';
import WorkFileTypes from '../Components/Pages/Types/WorkFileTypes/WorkFileTypes';
import Cities from '../Components/Pages/CitiesAndDistricts/Cities/Cities';
import Districts from '../Components/Pages/CitiesAndDistricts/Districts/Districts';
import Expenses from '../Components/Pages/FinancialOperations/Expenses/Expenses';
import PaymentCollections from '../Components/Pages/FinancialOperations/PaymentCollections/PaymentCollections';
import Notifications from '../Components/Pages/Notifications/Notifications';
//import Accounts from '../Components/Pages/Accounts/Accounts';
import Announcements from '../Components/Pages/Announcements/Announcements';
import ReportTypes from '../Components/Pages/Types/ReportTypes/ReportTypes';
import Arbitrators from '../Components/Pages/PersonDefinitions/Arbitrators/Arbitrators';
import ExpertWitnesses from '../Components/Pages/PersonDefinitions/ExpertWitnesses/ExpertWitnesses';
import Arbitration from '../Components/Pages/Arbitrations/ArbitrationDetails';
import CompensationDetail from '../Components/Pages/Compensations/CompensationDetail';
import DictionaryVariables from '../Components/Pages/AdminParameters/DictionaryVariables/DictionaryVariables';
import CompensationList from '../Components/Pages/Compensations/CompensationList';

export const routes = [
  // Örnek Sayfa
  { path: `${process.env.PUBLIC_URL}/sample-page`, Component: SamplePage },

  // Ana Sayfa
  { path: `${process.env.PUBLIC_URL}/dashboard`, Component: Dashboard },

  // Hazır Girdi Alanları
  { path: `${process.env.PUBLIC_URL}/insurance-companies`, Component: InsuranceCompanies },
  { path: `${process.env.PUBLIC_URL}/banks`, Component: Banks },

  // Yönetim Alanları
  { path: `${process.env.PUBLIC_URL}/job-pool`, Component: JobPool },
  { path: `${process.env.PUBLIC_URL}/employees`, Component: Employees },

  // Çağrı Formları
  { path: `${process.env.PUBLIC_URL}/callform/new-callform`, Component: CallForm },
  { path: `${process.env.PUBLIC_URL}/callform/new-callform/:id`, Component: CallForm },
  { path: `${process.env.PUBLIC_URL}/callform/:id`, Component: CallForm },
  { path: `${process.env.PUBLIC_URL}/callform/pending-callform`, Component: PendingCallForm },

  // İş Listesi
  { path: `${process.env.PUBLIC_URL}/todo-list`, Component: TodoList },

  // Müşteri Alanları
  { path: `${process.env.PUBLIC_URL}/customers`, Component: CustomerList },
  { path: `${process.env.PUBLIC_URL}/customer/:id`, Component: CustomerDetail },
  { path: `${process.env.PUBLIC_URL}/license-plates`, Component: LicensePlates },
  { path: `${process.env.PUBLIC_URL}/accidents`, Component: Accidents },
  { path: `${process.env.PUBLIC_URL}/accident-files`, Component: AccidentFiles },
  { path: `${process.env.PUBLIC_URL}/enforcements`, Component: Enforcements },

  // Kişi Tanımları
  { path: `${process.env.PUBLIC_URL}/arbitrators`, Component: Arbitrators },
  { path: `${process.env.PUBLIC_URL}/expert-witnesses`, Component: ExpertWitnesses },

  // Türler
  { path: `${process.env.PUBLIC_URL}/file-types`, Component: FileTypes },
  { path: `${process.env.PUBLIC_URL}/workfile-types`, Component: WorkFileTypes },
  { path: `${process.env.PUBLIC_URL}/report-types`, Component: ReportTypes },

  // Şehirler ve İlçeler
  { path: `${process.env.PUBLIC_URL}/cities`, Component: Cities },
  { path: `${process.env.PUBLIC_URL}/districts`, Component: Districts },

  // Finansal İşlemler
  { path: `${process.env.PUBLIC_URL}/expenses`, Component: Expenses },
  { path: `${process.env.PUBLIC_URL}/payment-collections`, Component: PaymentCollections },

  // Bildirimler
  { path: `${process.env.PUBLIC_URL}/notifications`, Component: Notifications },

  // Hesaplar
  // { path: `${process.env.PUBLIC_URL}/accounts/:id`, Component: Accounts },

  // Duyurular
  { path: `${process.env.PUBLIC_URL}/announcements`, Component: Announcements },

  // Tahkim
  { path: `${process.env.PUBLIC_URL}/arbitration/:id`, Component: Arbitration },

  // Kapak Detay Sayfası
  { path: `${process.env.PUBLIC_URL}/compensation-detail/:id`, Component: CompensationDetail },

  // Sabit Değişkenler
  { path: `${process.env.PUBLIC_URL}/dictionary-variables`, Component: DictionaryVariables },

  // Kapaklar
  { path: `${process.env.PUBLIC_URL}/compensations`, Component: CompensationList },
];